/*! For license information please see flexi_flexi_main.js.LICENSE.txt */ ! function() {
    var t = {
        "./src/js/main.js": function(t, e, i) {
            "use strict";
            var s = i("./src/utils/basics.js"),
                o = i("jquery");

            function n(t) {
                t.full && c(o(t.canvas), t.top);
                var e, i = {
                        frame: 0
                    },
                    s = gsap.utils.toArray(t.canvas)[0] || console.warn("canvas not defined"),
                    n = s.getContext("2d"),
                    r = -1,
                    l = t.onUpdate,
                    a = function() {
                        var o = Math.round(i.frame);
                        if (o !== r) {
                            t.clear && n.clearRect(0, 0, s.width, s.height);
                            var c, a, p, g, f = e[Math.round(i.frame)],
                                d = f.width / f.height,
                                h = s.width / s.height;
                            "contain" === t.objectFit ? (d <= h ? (p = d * s.height, g = s.height, c = (s.width - p) / 2, a = 0) : (g = (p = s.width) / d, c = 0, a = (s.height - g) / 2), n.drawImage(f, 0, 0, f.width, f.height, c, a, p, g)) : (d <= h ? (p = f.width, g = f.width / h, c = 0, a = (f.height - g) / 2) : (p = f.height * h, g = f.height, c = (f.width - p) / 2, a = 0), n.drawImage(f, c, a, p, g, 0, 0, s.width, s.height)), r = o, l && l.call(this, o, e[o])
                        }
                    };
                return window.addEventListener("resize", function(t, e) {
                    var i = null,
                        s = null,
                        o = null;

                    function n() {
                        (o = +new Date) - i < e ? s = setTimeout(n, e) : (t(), s = null), i = o
                    }
                    return function() {
                        i = +new Date, s || (s = setTimeout(n, e))
                    }
                }((function() {
                    c(o(t.canvas), t.top)
                }), 300), !1), e = t.urls.map((function(t, e) {
                    var i = new Image;
                    return i.src = t, e || (i.onload = a), i
                })), gsap.to(i, {
                    frame: e.length - 1,
                    ease: "none",
                    onUpdate: a,
                    duration: e.length / (t.fps || 30),
                    paused: !!t.paused,
                    scrollTrigger: t.scrollTrigger,
                    onComplete: t.onComplete
                })
            }

            function c(t, e) {
                var i = window.innerWidth,
                    s = window.innerWidth < 750 ? o(o.CN(".section-third .page-stickybox")).height() : window.innerHeight,
                    n = e ? s - (window.innerWidth < 1600 ? 50 : 60) : s,
                    c = window.devicePixelRatio;
                t.attr("width", Math.round(i * c)), t.attr("height", Math.round(n * c)), t.css("width", "".concat(i, "px")), t.css("height", "".concat(n, "px"))
            }

            function r(t) {
                return gsap.timeline({
                    yoyo: !0,
                    defaults: {
                        duration: .8,
                        delay: .3
                    },
                    scrollTrigger: {
                        trigger: t,
                        start: "top bottom",
                        toggleActions: "play pause resume reverse"
                    }
                }).fromTo(t, {
                    y: 15,
                    opacity: 0
                }, {
                    y: 0,
                    opacity: 1
                })
            }
            o(window).on("resize", (function(t) {})), o(document).ready((function() {
                var t, e, i, c;
                window.innerWidth < 750 ? (gsap.timeline({
                        defaults: {
                            duration: 1
                        },
                        scrollTrigger: {
                            trigger: o(o.CN(".section-second .sofa-block")),
                            start: "top bottom",
                            toggleActions: "play pause resume reset"
                        }
                    }).to(o(o.CN(".section-second .sofa-block .left")), {
                        left: 0
                    }).to(o(o.CN(".section-second .sofa-block .right")), {
                        right: 0
                    }, "<"), gsap.timeline({
                        yoyo: !0,
                        defaults: {
                            duration: .8
                        },
                        scrollTrigger: {
                            trigger: o(o.CN(".section-third")),
                            start: "top top",
                            toggleActions: "play pause resume reset"
                        }
                    }).fromTo(o.CN(".section-third .content-block"), {
                        opacity: 1
                    }, {
                        opacity: 1
                    }, ">").to(o.CN(".section-third .img4"), {
                        opacity: 1,
                        scale: 2
                    }, "<30%").to(o.CN(".section-third .img3"), {
                        opacity: 1,
                        scale: 2
                    }, "<").to(o.CN(".section-third .img2"), {
                        opacity: 1,
                        scale: 2
                    }, "<").to(o.CN(".section-third .img1"), {
                        opacity: 1,
                        scale: 2
                    }, "<"), gsap.timeline({
                        yoyo: !0,
                        scrollTrigger: {
                            trigger: o(o.CN(".section-third")),
                            start: "top top-=".concat(window.innerHeight, "px"),
                            end: "bottom bottom",
                            scrub: !0
                        }
                    }).to(o.CN(".section-third .p-desc"), {
                        opacity: 1
                    }, ">").to(o.CN(".section-third .white-line"), {
                        opacity: 1
                    }, "<").to(o.CN(".section-third .white-line"), {
                        left: "-15%"
                    }, ">").to(o.CN(".section-third .line-text"), {
                        opacity: 1
                    }, ">"), e = gsap.to(o.CN(".section-seventh .line-ball"), {
                        motionPath: {
                            path: "#line-path",
                            align: "#line-path",
                            offsetX: -4,
                            offsetY: -3
                        }
                    }, ">"), i = gsap.to(o.CN(".section-seventh .left .masker"), {
                        motionPath: {
                            path: "#line-path",
                            align: "#line-path",
                            offsetX: 3 - o(o.CN(".section-seventh .left .masker")).width(),
                            offsetY: -3
                        }
                    }, ">"), gsap.timeline({
                        yoyo: !0,
                        defaults: {
                            duration: .8
                        },
                        scrollTrigger: {
                            trigger: o(o.CN(".section-seventh")),
                            start: "top top",
                            toggleActions: "play pause resume reset"
                        }
                    }).to(o.CN(".section-seventh .content-block"), {
                        opacity: 1
                    }, ">"), gsap.timeline({
                        yoyo: !0,
                        scrollTrigger: {
                            trigger: o(o.CN(".section-seventh")),
                            start: "top top-=".concat(window.innerHeight, "px"),
                            end: "bottom bottom+=20%",
                            scrub: !0
                        }
                    }).add(e.reverse(0)).add(i.reverse(0), "<").to(o.CN(".section-seventh .angle-text"), {
                        opacity: 1
                    }, ">").to(o.CN(".section-seventh .height-text"), {
                        opacity: 1
                    }, ">"), gsap.timeline({
                        yoyo: !0,
                        defaults: {
                            duration: .8
                        },
                        scrollTrigger: {
                            trigger: o(o.CN(".section-tenth")),
                            start: "top top",
                            toggleActions: "play pause resume reset"
                        }
                    }).to(o.CN(".section-tenth .content-block"), {
                        opacity: 1
                    }, ">")) : (r(o(o.CN(".section-forth .right-block .p-subtitle"))), r(o(o.CN(".section-forth .right-block .p-desc"))), r(o("".concat(o.CN(".section-fifth"), " video"))), r(o(o.CN(".section-fifth .p-subtitle"))), r(o(o.CN(".section-fifth .p-desc"))), r(o(o.CN(".section-eighth .left-img"))), r(o(o.CN(".section-eighth .right-block .p-subtitle"))), r(o(o.CN(".section-eighth .right-block .p-desc"))), r(o(o.CN(".section-eighth .right-block .right-video"))), r(o(o.CN(".section-ninth .p-subtitle"))), r(o(o.CN(".section-ninth .p-desc"))), r(o(o.CN(".section-eleventh .bottom-block .p-subtitle"))), r(o(o.CN(".section-eleventh .bottom-block .p-desc"))), t = n({
                        urls: new Array(45).fill().map((function(t, e) {
                            return "".concat("/cdn/shop/", "files/").concat("flexi_flexi_", "C01_comp_").concat(e + 1, ".png")
                        })),
                        canvas: "#image-sequence1",
                        clear: !0,
                        objectFit: "contain",
                        full: !0,
                        top: !0
                    }), gsap.timeline({
                        yoyo: !0,
                        scrollTrigger: {
                            trigger: o(o.CN(".section-second .page-height")),
                            start: "top top+=".concat(window.innerWidth < 1600 ? 50 : 60, "px"),
                            end: "bottom bottom+=20%",
                            scrub: !0
                        }
                    }).fromTo(o(o.CN(".section-second .desc-block .p-desc")), {
                        y: -15,
                        opacity: 0
                    }, {
                        y: 0,
                        opacity: 1
                    }, ">").fromTo(o(o.CN(".section-second .desc-block .video-block")), {
                        y: -15,
                        opacity: 0
                    }, {
                        y: 0,
                        opacity: 1
                    }, "<25%").to(o(o.CN(".section-second .left-block")), {
                        x: "-12%"
                    }, ">").to(o(o.CN(".section-second .right-block")), {
                        x: "12%"
                    }, "<").to(o(o.CN(".section-second .desc-block")), {
                        opacity: 0
                    }, ">").to(o(o.CN(".section-second .left-block")), {
                        x: "-60%"
                    }, "<").to(o(o.CN(".section-second .right-block")), {
                        x: "-36%"
                    }, "<").to(o(o.CN(".section-second .sofa-img")), {
                        x: 0,
                        duration: 76 / 30
                    }, "<").add(t, "<").to(o(o.CN(".section-second .p1-block")), {
                        x: 0,
                        opacity: 1
                    }, ">").to(o(o.CN(".section-second .p2-block")), {
                        x: 0,
                        opacity: 1
                    }, "<50%").to(o(o.CN(".section-second .p3-block")), {
                        x: 0,
                        opacity: 1
                    }, "<50%").to(o(o.CN(".section-second .p4-block")), {
                        x: 0,
                        opacity: 1
                    }, "<50%").to(o(o.CN(".section-second .p5-block")), {
                        x: 0,
                        opacity: 1
                    }, "<50%").to(o(o.CN(".section-second .p6-block")), {
                        x: 0,
                        opacity: 1
                    }, "<50%").to(o(o.CN(".section-second .p7-block")), {
                        x: 0,
                        opacity: 1
                    }, "<50%"), gsap.timeline({
                        yoyo: !0,
                        defaults: {
                            duration: .8
                        },
                        scrollTrigger: {
                            trigger: o(o.CN(".section-third")),
                            start: "top top",
                            toggleActions: "play pause resume reset"
                        }
                    }).fromTo(o.CN(".section-third .content-block"), {
                        opacity: 0
                    }, {
                        opacity: 1
                    }, ">").fromTo(o.CN(".section-third .section3-img"), {
                        opacity: 0,
                        y: 15
                    }, {
                        opacity: 1,
                        y: 0
                    }, "<30%"), gsap.timeline({
                        yoyo: !0,
                        scrollTrigger: {
                            trigger: o(o.CN(".section-third")),
                            start: "top top".concat(window.innerHeight, "px"),
                            end: "bottom bottom",
                            scrub: !0
                        }
                    }).fromTo(o.CN(".section-third .p-desc"), {
                        y: 15,
                        opacity: 0
                    }, {
                        y: 0,
                        opacity: 1
                    }, ">").to(o.CN(".section-third .white-line"), {
                        opacity: 1
                    }, "<").to(o.CN(".section-third .white-line"), {
                        left: "-15%"
                    }, ">").to(o.CN(".section-third .line-text"), {
                        opacity: 1
                    }, ">"), function() {
                        var t = gsap.to(o.CN(".section-seventh .line-ball"), {
                                motionPath: {
                                    path: "#line-path",
                                    align: "#line-path",
                                    offsetX: -8,
                                    offsetY: -8
                                }
                            }, ">"),
                            e = gsap.to(o.CN(".section-seventh .left .masker"), {
                                motionPath: {
                                    path: "#line-path",
                                    align: "#line-path",
                                    offsetX: 5 - o(o.CN(".section-seventh .left .masker")).width(),
                                    offsetY: -5
                                }
                            }, ">"),
                            i = gsap.to(o.CN(".section-seventh .right .masker"), {
                                rotation: -90,
                                duration: .3,
                                paused: !0
                            });
                        gsap.timeline({
                            yoyo: !0,
                            defaults: {
                                duration: .8
                            },
                            scrollTrigger: {
                                trigger: o(o.CN(".section-seventh")),
                                start: "top top",
                                toggleActions: "play pause resume reset"
                            }
                        }).to(o.CN(".section-seventh .content-block"), {
                            opacity: 1
                        }, ">").fromTo(o.CN(".section-seventh .content-block .p-subtitle"), {
                            y: 15,
                            opacity: 0
                        }, {
                            y: 0,
                            opacity: 1
                        }, "<30%").fromTo(o.CN(".section-seventh .content-block .p-desc"), {
                            y: 15,
                            opacity: 0
                        }, {
                            y: 0,
                            opacity: 1
                        }, "<20%"), gsap.timeline({
                            yoyo: !0,
                            scrollTrigger: {
                                trigger: o(o.CN(".section-seventh")),
                                start: "top top-=".concat(window.innerHeight, "px"),
                                end: "bottom bottom",
                                scrub: !0,
                                onLeaveBack: function() {
                                    i.reverse()
                                }
                            }
                        }).add(t.reverse(0), ">").add(e.reverse(0), "<").to(o.CN(".section-seventh .height-text"), {
                            opacity: .9,
                            onComplete: function() {
                                i.play()
                            }
                        }, ">").to(o.CN(".section-seventh .height-text"), {
                            opacity: 1
                        }, ">")
                    }(), gsap.timeline({
                        yoyo: !0,
                        defaults: {
                            duration: .8
                        },
                        scrollTrigger: {
                            trigger: o(o.CN(".section-tenth")),
                            start: "top top",
                            toggleActions: "play pause resume reset"
                        }
                    }).fromTo(o.CN(".section-tenth .content-block .top-block .p-subtitle"), {
                        opacity: 0,
                        y: 15
                    }, {
                        opacity: 1,
                        y: 0
                    }, ">").fromTo(o.CN(".section-tenth .content-block .top-block .p-desc"), {
                        opacity: 0,
                        y: 15
                    }, {
                        opacity: 1,
                        y: 0
                    }, "<15%").fromTo(o.CN(".section-tenth .content-block .top-block .img"), {
                        opacity: 0,
                        y: 15
                    }, {
                        opacity: 1,
                        y: 0
                    }, "<15%").fromTo(o.CN(".section-tenth .content-block .bottom-block .img"), {
                        opacity: 0,
                        y: 15
                    }, {
                        opacity: 1,
                        y: 0
                    }, "<15%"), gsap.timeline({
                        yoyo: !0,
                        scrollTrigger: {
                            trigger: o(o.CN(".section-tenth")),
                            start: "top top-=".concat(2 * window.innerHeight, "px"),
                            end: "bottom bottom",
                            scrub: !0
                        }
                    }).to(o.CN(".section-tenth .tip"), {
                        opacity: 1
                    }), gsap.timeline({
                        yoyo: !0,
                        defaults: {
                            duration: .25
                        },
                        scrollTrigger: {
                            trigger: o(o.CN(".section-eleventh")),
                            start: "top 40%",
                            toggleActions: "play pause resume reverse"
                        },
                        ease: "power2.out"
                    }).to(o.CN(".section-eleventh .left-block .img1"), {
                        opacity: 1
                    }).to(o.CN(".section-eleventh .left-block .img2"), {
                        opacity: 1
                    }, ">").to(o.CN(".section-eleventh .left-block .img3"), {
                        opacity: 1
                    }, ">")), gsap.timeline({
                        yoyo: !0,
                        scrollTrigger: {
                            trigger: o(o.CN(".section-forth")),
                            start: "top top",
                            end: "bottom bottom",
                            scrub: !0
                        }
                    }).to(o.CN(".section-forth .left-block .litter"), {
                        opacity: 0
                    }).to(o.CN(".section-forth .left-block .line2"), {
                        opacity: 1
                    }, "<"),
                    function() {
                        var t = n({
                            urls: new Array(63).fill().map((function(t, e) {
                                return window.innerWidth < 750 ? "".concat("/cdn/shop/", "files/").concat("flexi_flexi_", "C03_mb_").concat(e + 1, ".png") : "".concat("/cdn/shop/", "files/").concat("flexi_flexi_", "C03_").concat(e + 1, ".png")
                            })),
                            canvas: "#image-sequence6",
                            clear: !0,
                            full: !0,
                            top: !0,
                            objectFit: window.innerWidth < 750 ? "cover" : "contain"
                        });
                        gsap.timeline({
                            yoyo: !0,
                            scrollTrigger: {
                                trigger: o(o.CN(".section-sixth")),
                                start: "top top",
                                end: "bottom bottom+=20%",
                                scrub: !0
                            }
                        }).to(o.CN(".section-sixth .section6-title-block"), {
                            opacity: 0
                        }).fromTo(o.CN(".section-sixth .sub"), {
                            opacity: 1
                        }, {
                            opacity: 0
                        }, "<").fromTo(o.CN(".section-sixth .desc"), {
                            y: 15,
                            opacity: 0
                        }, {
                            y: 0,
                            opacity: 1
                        }, ">").add(t, ">").fromTo(o.CN(".section-sixth .p-back-title"), {
                            y: o(o.CN(".section-sixth .p-back-title")).height()
                        }, {
                            y: 0
                        }, ">").fromTo(o.CN(".section-sixth .center-line"), {
                            y: 15,
                            opacity: 0
                        }, {
                            y: 0,
                            opacity: 1
                        }, "<25%")
                    }(), c = o(o.CN(".section-eleventh .time .hour-selected-list .list-item")).height(), gsap.timeline({
                        yoyo: !0,
                        defaults: {
                            duration: 3,
                            ease: "power1.out"
                        },
                        scrollTrigger: {
                            trigger: o(o.CN(".section-eleventh")),
                            start: "top 40%",
                            toggleActions: "play pause resume reset"
                        }
                    }).fromTo(o.CN(".section-eleventh .time .hour-selected-list"), {
                        y: 0
                    }, {
                        y: 8 * -c
                    }, ">").fromTo(o.CN(".section-eleventh .time .hour-selected-list .list-item:nth-child(1)"), {
                        rotateX: 0
                    }, {
                        rotateX: "-160deg"
                    }, "<").fromTo(o.CN(".section-eleventh .time .hour-selected-list .list-item:nth-child(2)"), {
                        rotateX: "20deg"
                    }, {
                        rotateX: "-140deg"
                    }, "<").fromTo(o.CN(".section-eleventh .time .hour-selected-list .list-item:nth-child(3)"), {
                        rotateX: "40deg"
                    }, {
                        rotateX: "-120deg"
                    }, "<").fromTo(o.CN(".section-eleventh .time .hour-selected-list .list-item:nth-child(4)"), {
                        rotateX: "60deg"
                    }, {
                        rotateX: "-100deg"
                    }, "<").fromTo(o.CN(".section-eleventh .time .hour-selected-list .list-item:nth-child(5)"), {
                        rotateX: "80deg"
                    }, {
                        rotateX: "-80deg"
                    }, "<").fromTo(o.CN(".section-eleventh .time .hour-selected-list .list-item:nth-child(6)"), {
                        rotateX: "100deg"
                    }, {
                        rotateX: "-60deg"
                    }, "<").fromTo(o.CN(".section-eleventh .time .hour-selected-list .list-item:nth-child(7)"), {
                        rotateX: "120deg"
                    }, {
                        rotateX: "-40deg"
                    }, "<").fromTo(o.CN(".section-eleventh .time .hour-selected-list .list-item:nth-child(8)"), {
                        rotateX: "140deg"
                    }, {
                        rotateX: "-20deg"
                    }, "<").fromTo(o.CN(".section-eleventh .time .hour-selected-list .list-item:nth-child(9)"), {
                        rotateX: "160deg"
                    }, {
                        rotateX: "0"
                    }, "<").fromTo(o.CN(".section-eleventh .time .hour-selected-list .list-item:nth-child(10)"), {
                        rotateX: "180deg"
                    }, {
                        rotateX: "20deg"
                    }, "<").fromTo(o.CN(".section-eleventh .time .hour-selected-list .list-item:nth-child(11)"), {
                        rotateX: "200deg"
                    }, {
                        rotateX: "40deg"
                    }, "<").fromTo(o.CN(".section-eleventh .time .min-selected-list"), {
                        y: 0
                    }, {
                        y: 5 * -c
                    }, "<").fromTo(o.CN(".section-eleventh .time .min-selected-list .list-item:nth-child(1)"), {
                        rotateX: 0
                    }, {
                        rotateX: "-100deg"
                    }, "<").fromTo(o.CN(".section-eleventh .time .min-selected-list .list-item:nth-child(2)"), {
                        rotateX: "20deg"
                    }, {
                        rotateX: "-80deg"
                    }, "<").fromTo(o.CN(".section-eleventh .time .min-selected-list .list-item:nth-child(3)"), {
                        rotateX: "40deg"
                    }, {
                        rotateX: "-60deg"
                    }, "<").fromTo(o.CN(".section-eleventh .time .min-selected-list .list-item:nth-child(4)"), {
                        rotateX: "60deg"
                    }, {
                        rotateX: "-40deg"
                    }, "<").fromTo(o.CN(".section-eleventh .time .min-selected-list .list-item:nth-child(5)"), {
                        rotateX: "80deg"
                    }, {
                        rotateX: "-20deg"
                    }, "<").fromTo(o.CN(".section-eleventh .time .min-selected-list .list-item:nth-child(6)"), {
                        rotateX: "100deg"
                    }, {
                        rotateX: "0deg"
                    }, "<"), gsap.timeline({
                        yoyo: !0,
                        defaults: {
                            duration: .8
                        },
                        scrollTrigger: {
                            trigger: o(o.CN(".section-twelfth")),
                            start: "top top",
                            toggleActions: "play pause resume reset"
                        }
                    }).to(o.CN(".section-twelfth .area-block"), {
                        opacity: 1
                    }, ">").to(o.CN(".section-twelfth .center-line"), {
                        opacity: 1
                    }, "<30%").fromTo(o.CN(".section-twelfth .title-line .p-subtitle"), {
                        y: 15,
                        opacity: 0
                    }, {
                        y: 0,
                        opacity: 1
                    }, "<30%").fromTo(o.CN(".section-twelfth .title-line .p-desc"), {
                        y: 15,
                        opacity: 0
                    }, {
                        y: 0,
                        opacity: 1
                    }, "<").fromTo(o.CN(".section-twelfth .bottom-line .p-bottom-title"), {
                        y: 15,
                        opacity: 0
                    }, {
                        y: 0,
                        opacity: 1
                    }, "<30%").fromTo(o.CN(".section-twelfth .bottom-line .p-desc"), {
                        y: 15,
                        opacity: 0
                    }, {
                        y: 0,
                        opacity: 1
                    }, "<30%"), (0, s.basics)()
            })), window.onload = function() {}
        },
        "./src/utils/basics.js": function(t, e, i) {
            "use strict";
            i.d(e, {
                basics: function() {
                    return o
                }
            });
            var s = i("jquery");

            function o() {
                function t() {
                    s(s.CN(".full_screen_video")).hide();
                    var t = new window.CustomEvent("hide.all.modals");
                    document.dispatchEvent(t)
                }! function() {
                    var t = document.querySelectorAll(s.CN(".as-youtube-video"));
                    if (t.length > 0) {
                        var e = document.createElement("script");
                        e.src = "https://www.youtube.com/iframe_api";
                        var i = document.getElementsByTagName("script")[0];
                        i.parentNode.insertBefore(e, i);
                        var o = [],
                            n = function(t) {
                                document.addEventListener("hide.all.modals", (function(t) {
                                    for (var e = 0; e < o.length; e++) o[e].pauseVideo()
                                }))
                            };
                        window.onYouTubeIframeAPIReady = function() {
                            for (var e = 0; e < t.length; e++) o.push(new window.YT.Player(t[e], {
                                events: {
                                    onReady: n
                                }
                            }))
                        }
                    }
                }(), s("#sideBtn").on("click", (function() {
                    var t = s(s.CN(".serise-container"));
                    t.hasClass(s.CN("show")) ? t.addClass(s.CN("hide")).removeClass(s.CN("show")) : t.addClass(s.CN("show")).removeClass(s.CN("hide"))
                })), s("#popup-tab").delegate(s.CN(".tabTitle"), "click", (function(t) {
                    s(this).addClass(s.CN("active")).siblings().removeClass(s.CN("active")), s(s.CN(".tabbody .tabCard")).eq(s(this).index()).show().siblings().hide(), s(s.CN(".pc .img")).eq(s(this).index()).addClass(s.CN("active")).siblings().removeClass(s.CN("active")), s(s.CN(".mob .img")).eq(s(this).index()).addClass(s.CN("active")).siblings().removeClass(s.CN("active"))
                })), s(s.CN(".section-second .videoBtn")).on("click", (function(e) {
                    s(s.CN(".full_screen_video")).show()
                })), s(s.CN(".full_screen_video")).on("click", (function(e) {
                    t()
                })), s(s.CN(".full_screen_video .video-close")).on("click", (function(e) {
                    t()
                })), s("#product_subscription_b").on("click", (function() {
                    s("#subscribe-modal").css({
                        display: "block"
                    })
                }))
            }
        },
        "./src/utils/index.js": function(t, e, i) {
            ! function(t) {
                t.extend({
                    CN: function(t) {
                        return t.startsWith(".") ? t.split(" ").map((function(t) {
                            return ".".concat("flexi_flexi_").concat(t.slice(1))
                        })).join(" ") : "flexi_flexi_" + t
                    }
                })
            }(i("jquery"))
        },
        "./src/utils/language.js": function(t, e, i) {
            i("jquery");
            ! function(t) {
                document.documentElement.clientWidth || window.innerWidth
            }()
        },
        "./src/index.html": function(t, e, i) {
            "use strict";
            var s = i("./node_modules/html-loader/dist/runtime/getUrl.js"),
                o = i.n(s),
                n = new URL(i("./src/utils/gsap3.11.5.min.js"), i.b),
                c = new URL(i("./src/utils/ScrollTrigger3.11.5.min.js"), i.b),
                r = new URL(i("./src/utils/MotionPath3.11.5.min.js"), i.b),
                l = new URL(i("./src/assets/images/section1-img.jpg"), i.b),
                a = new URL(i("./src/assets/images/section1-img-mb.jpg"), i.b),
                p = new URL(i("./src/assets/images/section1-reddot.png"), i.b),
                g = new URL(i("./src/assets/images/section1-reddot_m.png"), i.b),
                f = new URL(i("./src/assets/images/section1-left.png"), i.b),
                d = new URL(i("./src/assets/video/section1-video.mp4"), i.b),
                h = new URL(i("./src/assets/images/play.png"), i.b),
                m = new URL(i("./src/assets/images/section1-left-mb.png"), i.b),
                u = new URL(i("./src/assets/images/section1-right-mb.png"), i.b),
                y = new URL(i("./src/assets/images/section3-4.png"), i.b),
                b = new URL(i("./src/assets/images/section3-3.png"), i.b),
                x = new URL(i("./src/assets/images/section3-2.png"), i.b),
                C = new URL(i("./src/assets/images/section3-1.png"), i.b),
                N = new URL(i("./src/assets/images/section4-litter.png"), i.b),
                w = new URL(i("./src/assets/images/section4-dashboard.png"), i.b),
                v = new URL(i("./src/assets/images/section4-bottom.jpg"), i.b),
                _ = new URL(i("./src/assets/video/section5.mp4"), i.b),
                A = new URL(i("./src/assets/images/tuvlabel.png"), i.b),
                T = new URL(i("./src/assets/images/tuvlabel4xx.png"), i.b),
                k = new URL(i("./src/assets/images/section7-left.png"), i.b),
                j = new URL(i("./src/assets/images/section9-img.png"), i.b),
                R = new URL(i("./src/assets/images/section10-1.jpg"), i.b),
                U = new URL(i("./src/assets/images/section10-1-mb.jpg"), i.b),
                L = new URL(i("./src/assets/images/section10-2.jpg"), i.b),
                X = new URL(i("./src/assets/images/section10-2-mb.jpg"), i.b),
                B = new URL(i("./src/assets/images/section11-left1.png"), i.b),
                H = new URL(i("./src/assets/images/section11-left2.png"), i.b),
                Y = new URL(i("./src/assets/images/section11-left3.png"), i.b),
                q = new URL(i("./src/assets/images/section11-right.png"), i.b),
                I = new URL(i("./src/assets/images/section12-left.png"), i.b),
                W = new URL(i("./src/assets/images/section12-center.png"), i.b),
                K = new URL(i("./src/assets/images/section12-right.png"), i.b),
                Q = new URL(i("./src/assets/images/compare-flexi-pro.png"), i.b),
                S = new URL(i("./src/assets/images/compare-flexi.png"), i.b),
                M = new URL(i("./src/assets/images/compare-flexi-lite.png"), i.b);
            o()(n), o()(c), o()(r), o()(l), o()(a), o()(p), o()(g), o()(f), o()(d), o()(h), o()(m), o()(u), o()(y), o()(b), o()(x), o()(C), o()(N), o()(w), o()(v), o()(_), o()(A), o()(T), o()(k), o()(j), o()(R), o()(U), o()(L), o()(X), o()(B), o()(H), o()(Y), o()(q), o()(I), o()(W), o()(K), o()(Q), o()(S), o()(M)
        },
        "./node_modules/html-loader/dist/runtime/getUrl.js": function(t) {
            "use strict";
            t.exports = function(t, e) {
                return e || (e = {}), t ? (t = String(t.__esModule ? t.default : t), e.hash && (t += e.hash), e.maybeNeedQuotes && /[\t\n\f\r "'=<>`]/.test(t) ? '"'.concat(t, '"') : t) : t
            }
        },
        "./src/utils/MotionPath3.11.5.min.js": function(t, e, i) {
            "use strict";
            t.exports = i.p + "assets/flexi_flexi_MotionPath3.11.5.min.js"
        },
        "./src/utils/ScrollTrigger3.11.5.min.js": function(t, e, i) {
            "use strict";
            t.exports = i.p + "assets/flexi_flexi_ScrollTrigger3.11.5.min.js"
        },
        "./src/utils/gsap3.11.5.min.js": function(t, e, i) {
            "use strict";
            t.exports = i.p + "assets/flexi_flexi_gsap3.11.5.min.js"
        },
        "./src/assets/images/compare-flexi-lite.png": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_compare-flexi-lite.png"
        },
        "./src/assets/images/compare-flexi-pro.png": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_compare-flexi-pro.png"
        },
        "./src/assets/images/compare-flexi.png": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_compare-flexi.png"
        },
        "./src/assets/images/play.png": function(t) {
            "use strict";
            t.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAA3CAYAAABKB8k/AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHWSURBVHgB1ZqNUcJAEIU3jgVYAiVoBUIlSgViBcQKxAqileSs5K4D6OC5S8yIGRKScD9738ybYUhg7rFvLzlyRCcAuBNRbvCg71k1/pDXS8oBHuiCtcd5KjlOmun88n2UaqOF8VjWE2kD07HQFCvMp1JhBNchzV9SSuAHi1T9Ab/UiB0rhKGKZgThsKwNhQbhsQjZH4hHhQCxKuSbKS471kdRFI58gDRYeIpVigqc4lhrroahmdxQWhasGlf0R+oKdHlj7bgih7Ef0GZAcKySTXyNOVmjgRbHWl2arVL3wBALlr3UH5orcIr0hFw7yu6BXAy0OOr0R24GWgw11w+XqwFBYvWQswHB5G7goHkaHUXuBrKO0LGJc62AIZmBeBq9pbxwrGce+Hf7Ri4GJC7tUvTfrXYOBj5Zr31rBM09YFhLHvh6aIGjsQIy2M3YBY0mA705H0KLAUO/d5c0kdQ9YKjJ+aqY+0cX0iAPRl7IAykiVNLEnA8R04ChmTkfIoYBR53Lv1cQDsn5lkKDMLwj1pN9+KVmPVJM4AcbfeCeDBxzjpQbQTCfChp2sGA6NVLF5Rzo3+zURc5Tud2mHjHwrYq4nAPNfrn9QFwWpB00++ZqtTkf4AemeIMa5th32wAAAABJRU5ErkJggg=="
        },
        "./src/assets/images/section1-img-mb.jpg": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_section1-img-mb.jpg"
        },
        "./src/assets/images/section1-img.jpg": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_section1-img.jpg"
        },
        "./src/assets/images/section1-left-mb.png": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_section1-left-mb.png"
        },
        "./src/assets/images/section1-left.png": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_section1-left.png"
        },
        "./src/assets/images/section1-reddot.png": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_section1-reddot.png"
        },
        "./src/assets/images/section1-reddot_m.png": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_section1-reddot_m.png"
        },
        "./src/assets/images/section1-right-mb.png": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_section1-right-mb.png"
        },
        "./src/assets/images/section10-1-mb.jpg": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_section10-1-mb.jpg"
        },
        "./src/assets/images/section10-1.jpg": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_section10-1.jpg"
        },
        "./src/assets/images/section10-2-mb.jpg": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_section10-2-mb.jpg"
        },
        "./src/assets/images/section10-2.jpg": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_section10-2.jpg"
        },
        "./src/assets/images/section11-left1.png": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_section11-left1.png"
        },
        "./src/assets/images/section11-left2.png": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_section11-left2.png"
        },
        "./src/assets/images/section11-left3.png": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_section11-left3.png"
        },
        "./src/assets/images/section11-right.png": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_section11-right.png"
        },
        "./src/assets/images/section12-center.png": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_section12-center.png"
        },
        "./src/assets/images/section12-left.png": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_section12-left.png"
        },
        "./src/assets/images/section12-right.png": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_section12-right.png"
        },
        "./src/assets/images/section3-1.png": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_section3-1.png"
        },
        "./src/assets/images/section3-2.png": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_section3-2.png"
        },
        "./src/assets/images/section3-3.png": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_section3-3.png"
        },
        "./src/assets/images/section3-4.png": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_section3-4.png"
        },
        "./src/assets/images/section4-bottom.jpg": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_section4-bottom.jpg"
        },
        "./src/assets/images/section4-dashboard.png": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_section4-dashboard.png"
        },
        "./src/assets/images/section4-litter.png": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_section4-litter.png"
        },
        "./src/assets/images/section7-left.png": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_section7-left.png"
        },
        "./src/assets/images/section9-img.png": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_section9-img.png"
        },
        "./src/assets/images/tuvlabel.png": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_tuvlabel.png"
        },
        "./src/assets/images/tuvlabel4xx.png": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_tuvlabel4xx.png"
        },
        "./src/assets/video/section1-video.mp4": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_section1-video.mp4"
        },
        "./src/assets/video/section5.mp4": function(t, e, i) {
            "use strict";
            t.exports = i.p + "files/flexi_flexi_section5.mp4"
        },
        jquery: function(t) {
            "use strict";
            t.exports = $
        }
    },
    e = {};

function i(s) {
    var o = e[s];
    if (void 0 !== o) return o.exports;
    var n = e[s] = {
        exports: {}
    };
    return t[s](n, n.exports, i), n.exports
}
i.m = t, i.n = function(t) {
        var e = t && t.__esModule ? function() {
            return t.default
        } : function() {
            return t
        };
        return i.d(e, {
            a: e
        }), e
    }, i.d = function(t, e) {
        for (var s in e) i.o(e, s) && !i.o(t, s) && Object.defineProperty(t, s, {
            enumerable: !0,
            get: e[s]
        })
    }, i.o = function(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e)
    }, i.p = "/cdn/shop/", i.b = document.baseURI || self.location.href,
    function() {
        "use strict";
        i("./src/index.html"), i("./src/utils/index.js"), i("./src/js/main.js"), i("./src/utils/language.js")
    }()
}();